import React from "react";
import Buy from "../../images/social-iaamarketplace/live-monitoring.svg";
import Sell from "../../images/social-iaamarketplace/live-monitoring.svg";
import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";

export default function PartnerFeatures() {
  const benefits = [

   
      {
      img: Buy,
      title: "Identity and Access Management (IAM) Services",
      bodycopy: "Ensures secure authentication and authorization through Keycloak, AuthProxy, and the OTP Authentication Plugin.  ",
    },
    {
      img: Sell,
      title: "Registration Services",
      bodycopy:
      "Supports user and business registration via the Register Gateway and the Agri Business Registry Service.",
    },

    {
      img: Buy,
      title: "Content & Services Management",
      bodycopy: "Efficiently manages QR codes, agri-products, documents, and billing services through a robust content delivery system.      ",
    },
    {
      img: Sell,
      title: "Enterprise Asset Management (EAM) Services",
      bodycopy:
      "Enables real-time tracking, maintenance, and management of enterprise assets through EAM and EAP services.",
    },

    {
      img: Buy,
      title: "Microservices-Based Architecture",
      bodycopy: "Offers a decentralized and scalable backend, providing services such as analytics, advisory, booking, and configuration management. ",
    },
    {
      img: Sell,
      title: "Secure Proxy Services & API Gateways",
      bodycopy:
      "Facilitates secure data flow and integration via the Advisory Proxy, Analytics Proxy, and Cloud Storage Gateway. ",
    },

    {
      img: Sell,
      title: "Blockchain Integration for Transparency",
      bodycopy:
      "Utilizes the Enterprise Activation Server, Blockchain Network Client, and Blockchain Proxy Server to ensure secure and immutable transactions.",
    },
    {
      img: Sell,
      title: "Cloud Gateway for Scalable Services",
      bodycopy:
      "Integrates seamlessly with Standard-Gw, MQTT, RabbitMQ, and Service Endpoints (SEP) for cloud interactions.",
    },

    {
      img: Sell,
      title: "Advanced Device Management",
      bodycopy:
      "Provides remote monitoring, firmware updates, and secure connectivity for IoT devices. ",
    },
    {
      img: Sell,
      title: "Secure Authentication and Multi-Factor Security",
      bodycopy:
      "Implements OTP authentication, key-based authorization, and encrypted data handling for enhanced security. ",
    },

    {
      img: Sell,
      title: "Centralized Order Management",
      bodycopy:
      "Streamlines order tracking and processing using the Order Proxy, Order Proxy Adapter, and QRProxy.",
    },
    {
      img: Sell,
      title: "Smart Document Management System",
      bodycopy:
      "Supports document creation, retrieval, billing, and transport management via GenDoc services. ",
    },

    {
      img: Sell,
      title: "Decentralized Financial Transactions with Wallet Services",
      bodycopy:
      " Facilitates secure digital payments, transactions, and wallet management through the Wallet Server and Wallet Gateway.",
    },
    {
      img: Sell,
      title: "Scalable Notification & Alert System",
      bodycopy:
      "Provides real-time updates and alerts for business-critical operations using Notification UA.",
    },

    {
      img: Sell,
      title: "Partner Portal for Seamless Business Operations",
      bodycopy:
      "Enables business collaboration, service customization, and data exchange through the Partner Application.",
    },
     
  ];
  return (
    <div className="main-wrapper">
          <Container className="subSectionWrapper ">
      <h2 className="text-center container-title mb-4">
          Features
      </h2>
      <Row className="justify-content-center">
        {benefits.map((e, index) => {
          return (
            <Col md={4} className="d-flex" key={index}>
              <BenefitsCard src={e.img} title={e.title} bodycopy={e.bodycopy} />
            </Col>
          );
        })}
      </Row>
      </Container>
    </div>
  );
}
